import React, {Component} from "react";
import Body from "../../../../../assets/body/Body";
import utils from "../../../../../utils/utils";
import AudioPlayer from "../../../../media/AudioPlayer";

class HeartExam extends Component {

    constructor(props) {
        super(props);
        this.state = {
            playingDot: null,
            isA: false,
            isB: false,
            isC: false,
            isD: false
        }
    }

    render() {
        let {files, patient} = this.props
        let body = <div/>
        if (!!files && !!patient)
            body = <Body activeDot={this.state.playingDot} gender={patient.gender}
                         age={utils._calculateAge(new Date(patient['birthday']))} part={'heart'} className={'exam-body'}
                         name={'exam-body'} files={files}/>

        let A_files = files.filter(file => file['dotName'] === 'A')
        let B_files = files.filter(file => file['dotName'] === 'B')
        let C_files = files.filter(file => file['dotName'] === 'C')
        let D_files = files.filter(file => file['dotName'] === 'D')
        return (
            <div className={'exam-result-container heart-exam-container'}>
                <div className={'exam-res-container h-centered'}>
                    {body}
                    <div className={'stethoscope-audios'}>
                        {A_files.length > 0 && <AudioPlayer playing={this.state.isA} play={bool => this.setState({
                            isA: bool,
                            isB: false,
                            isC: false,
                            isD: false,
                            playingDot: bool ? 'A' : null
                        })} title={'A'} className={'heart-exam-player stethoscope-audio'} files={A_files}/>}
                        {B_files.length > 0 && <AudioPlayer playing={this.state.isB} play={bool => this.setState({
                            isA: false,
                            isB: bool,
                            isC: false,
                            isD: false,
                            playingDot: bool ? 'B' : null
                        })} title={'B'} className={'heart-exam-player stethoscope-audio'} files={B_files}/>}
                        {C_files.length > 0 && <AudioPlayer playing={this.state.isC} play={bool => this.setState({
                            isA: false,
                            isB: false,
                            isC: bool,
                            isD: false,
                            playingDot: bool ? 'C' : null
                        })} title={'C'} className={'heart-exam-player stethoscope-audio'} files={C_files}/>}
                        {D_files.length > 0 && <AudioPlayer playing={this.state.isD} play={bool => this.setState({
                            isA: false,
                            isB: false,
                            isC: false,
                            isD: bool,
                            playingDot: bool ? 'D' : null
                        })} title={'D'} className={'heart-exam-player stethoscope-audio'} files={D_files}/>}
                    </div>
                </div>

            </div>
        );
    }

}

export default HeartExam
